module.exports = __webpack_public_path__ + "media/src/assets/Images/CheckExtra-d35ea2b4d1956f7aadaf2971af78c0c5.svg";